// Single source of truth for role -> dashboard route.
// Previously this exact map was duplicated in 4 places (LoginPage.jsx x3,
// ProtectedRoute.jsx x1) and had silently drifted out of sync — STORE_MANAGER
// was missing from all of them, which caused an infinite redirect loop
// (LoginPage sends the user to their dashboard -> ProtectedRoute's allowedRoles
// rejects them -> falls back to a route map that also doesn't know the role ->
// bounces to /login -> LoginPage sends them again -> forever).
// Import this everywhere a role needs to be turned into a route instead of
// hardcoding another copy.
export const ROLE_DASHBOARD_ROUTES = {
  ADMIN: '/admin-dashboard',
  STUDENT: '/student-dashboard',
  INTERN: '/student-dashboard',
  FACULTY: '/faculty-dashboard',
  FINANCE: '/finance-dashboard',
  HOSTEL_ADMIN: '/hostel-dashboard',
  STORE_MANAGER: '/hostel-dashboard',
  LIBRARY_STAFF: '/library-dashboard',
  TRANSPORT_MANAGER: '/transport-dashboard',
  DRIVER: '/driver-dashboard',
  recepsonist: '/reception',
  LAB_TECH_MICROBIOLOGY: '/lab-dashboard',
  LAB_TECH_PATHOLOGY: '/lab-dashboard',
  LAB_TECH_BIOCHEMISTRY: '/lab-dashboard',
  BILLING_MEMBER: '/lab-billing',
  BILLING_MANAGER: '/billing-manager',
  SAMPLE_COLLECTOR: '/sample-collection',
  REPORT_GENERATION: '/report-generation',
  GRIEVANCE_OFFICER: '/grievance-officer-dashboard',
  PRINCIPAL: '/principal-dashboard',
  DEAN: '/dean-dashboard',
  PARENT: '/parent-dashboard',
  COE: '/coe-dashboard',
  PAPER_EVALUATOR: '/paper-evaluator-dashboard',
};

/**
 * Resolves the correct dashboard route for a user, accounting for the
 * FACULTY role's subrole-based split (HOD vs Professor+HOD vs regular faculty).
 */
export function getDashboardPathForUser(user) {
  if (!user) return '/login';
  const subrole = user.profile?.faculty_subrole;

  if (user.role === 'FACULTY' && subrole === 'HEAD_OF_DEPARTMENT') {
    return '/hod-dashboard';
  }
  if (user.role === 'FACULTY' && subrole === 'PROFESSOR_HOD') {
    return '/faculty-dashboard';
  }

  return ROLE_DASHBOARD_ROUTES[user.role] || '/login';
}
